import React, { useState, useEffect, useContext } from "react";
import swal from "sweetalert";
import * as Service from "../../services/Service.js";
// material components
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import makeStyles from '@mui/styles/makeStyles';
import { addDays, format, subDays } from 'date-fns';

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { useQuery, useMutation } from "@tanstack/react-query";
import * as api from "../../actions/api";

import {
  Typography,
  TextField,
  Card,
  Checkbox,
  InputLabel,
  CardHeader,
  CardContent,
  Select,
  FormLabel,
  MenuItem,
  FormControl,
  Grid,
} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr, enGB } from "date-fns/locale";
import { DatePicker } from "@mui/x-date-pickers";

import Autocomplete from '@mui/material/Autocomplete';

import { Button } from "reactstrap";
import encryptionService from "../../services/encryptionService";
// core components
import AfterLoginNavbar from "components/Navbars/AfterLoginNavbar.js";

import { getDefaultMonthYear, getARVFacilityList } from "../../services/Common";

import { useTranslation } from "react-i18next";
import {
  checkLogin,
  checkUserPermission,
  getUserActionPermission,
} from "../../services/CheckUserAccess";




const ReportPage = (props) => {
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const { t, i18n } = useTranslation();
  const menukey = "information-sheet-for-plhiv-patients-on-inh-prophylaxis";
  const FacilityId = localStorage.getItem("FacilityId");
  //const YearList = JSON.parse(localStorage.getItem("YearList"));
  //const MonthList = JSON.parse(localStorage.getItem("MonthList"));

  const [currPorductId, setcurrPorductId] = useState(0);

  /* start new filter */

  /* const [selectedStartDate, setSelectedStartDate] = React.useState(
  format(subDays(new Date(), 30), 'yyyy-MM-01')
);
 */
  /* const handleStartDateChange = (date) => {
  setSelectedStartDate(date);
  setLoading(true);
};
 */
  /* const [selectedEndDate, setSelectedEndDate] = React.useState(
  format(new Date(), 'yyyy-MM-dd')
);

const handleEndDateChange = (date) => {
  setSelectedEndDate(date);
  setLoading(true);
};
 */

  /*   let All_Facility_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All Facility"])};
  const FacilityList = [All_Facility_label].concat(getARVFacilityList());
  const [Facilitylist, setFacilitylist] = useState(FacilityList);
  const bFacilitySelected = localStorage.getItem("bFacilitySelected");
  const [currFacilityId, setCurrFacilityId] = useState(bFacilitySelected == 1 ? FacilityId: 0); */

  /*   let TempKeyPopulationTypeList = JSON.parse(localStorage.getItem("KeyPopulationType_List"));
  let All_KeyPopulationType_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All Key Population Type"])};
  const KeyPopulationType_List = [All_KeyPopulationType_label].concat(TempKeyPopulationTypeList); 
  const [KeyPopulationTypelist, setKeyPopulationTypelist] = useState(KeyPopulationType_List);
  const [currKeypopulationTypeId, setCurrKeypopulationTypeId] = useState(0); */

  const bFacilitySelected = localStorage.getItem("bFacilitySelected");
  const UserInfo = encryptionService.decryptUserInfo();
  const defaultRegionId = UserInfo == 0 ? 0 : UserInfo[0].RegionId;
  const defaultZoneId = UserInfo == 0 ? 0 : UserInfo[0].ZoneId;
  const defaultDistrictId = UserInfo == 0 ? 0 : UserInfo[0].DistrictId;

  const objAll = { id: "0", name: t(DispensingLanguage[lan][menukey]["All"]) };

  const Regionlist = JSON.parse(localStorage.getItem("Regionlist"));
  Regionlist.unshift(objAll);
  const [currRegionId, setcurrRegionId] = useState(
    bFacilitySelected == 1 ? defaultRegionId : 0
  );
  const [chosenValuesRegion, setChosenValuesRegion] = useState(
    bFacilitySelected == 1
      ? (Regionlist.find((list) => list.id == defaultRegionId) ?? null)
      : objAll
  );

  let TempZSList = useState([]);
  const [ZoneList, setZoneListLocal] = useState(TempZSList);
  //const [currZoneId, setcurrZoneId] = useState(0);
  const [currZoneId, setcurrZoneId] = useState(
    bFacilitySelected == 1 ? defaultZoneId : 0
  );
  const [chosenValuesZone, setChosenValuesZone] = useState({});

  let TempCommuneList = useState([]);
  const [CommuneList, setCommuneListLocal] = useState(TempCommuneList);
  //const [currCommuneId, setcurrCommuneId] = useState(0);
  const [currCommuneId, setcurrCommuneId] = useState(
    bFacilitySelected == 1 ? defaultDistrictId : 0
  );
  /* const [chosenValuesDistrict, setChosenValuesDistrict] = useState({
    "DistrictId": objAll
  }); */

  const [chosenValuesDistrict, setChosenValuesDistrict] = useState({});

  let TempFacilityList = useState([]);
  const [FacilityList, setFacilityListLocal] = useState(TempFacilityList);
  const [currFacilityId, setcurrFacilityId] = useState(
    bFacilitySelected == 1 ? FacilityId : 0
  );
  const [chosenValuesFacility, setChosenValuesFacility] = useState({});

  React.useEffect(() => {
    cZoneList();
    console.log("RegionId useEffect", Date());
  }, [currRegionId]);

  React.useEffect(() => {
    cCommuneList();
    console.log("RegionId Zone useEffect", Date());
  }, [currRegionId, currZoneId]);

  React.useEffect(() => {
    cFacilityList();
    console.log("RegionId Zone Commu useEffect", Date());
  }, [currRegionId, currZoneId, currCommuneId]);

  //====== Start Choosen Dropdown===========

  const handleChangeChoosenRegion = (name, valueobj, value) => {
    /*  let chosenValuesDataRegion = { ...chosenValuesRegion};
  chosenValuesDataRegion[name] = valueobj; */
    setChosenValuesRegion(valueobj);

    /* setFirstLoad(true); */
    setLoading(false);
    setcurrRegionId(value);

    setcurrZoneId(0);
    setcurrCommuneId(0);
    setcurrFacilityId(0);

    setChosenValuesZone(objAll);
    setChosenValuesDistrict(objAll);
    setChosenValuesFacility(objAll);
  };

  const handleChangeChoosenZone = (name, valueobj, value) => {
    /* let chosenValuesDataZone = { ...chosenValuesZone};
  chosenValuesDataZone[name] = valueobj; */
    setChosenValuesZone(valueobj);

    /* setFirstLoad(true); */
    setLoading(false);
    setcurrZoneId(value);

    setcurrCommuneId(0);
    setcurrFacilityId(0);

    setChosenValuesDistrict(objAll);
    setChosenValuesFacility(objAll);
  };

  const handleChangeChoosenDistrict = (name, valueobj, value) => {
    /* let chosenValuesDataDistrict = { ...chosenValuesDistrict};
  chosenValuesDataDistrict[name] = valueobj; */
    setChosenValuesDistrict(valueobj);

    setLoading(false);
    setcurrCommuneId(value);

    setcurrFacilityId(0);
    setChosenValuesFacility(objAll);
  };

  const handleChangeChoosenFacility = (name, valueobj, value) => {
    /*  let chosenValuesDataFacility = { ...chosenValuesFacility};
  chosenValuesDataFacility[name] = valueobj; */
    setChosenValuesFacility(valueobj);

    setLoading(false);
    setcurrFacilityId(value);
  };

  //====== End Choosen Dropdown===========

  const cZoneList = () => {
    let ZoneListParam = {
      action: "Zonelist",
      RegionId: currRegionId,
      FacilityId: FacilityId,
      menukey: "",
    };

    Service.default
      .postApi("source/combo_generic.php", ZoneListParam)
      .then((res) => {
        let All_Zone_label = objAll;
        const Zone_List = [All_Zone_label].concat(res.datalist);
        setZoneListLocal(Zone_List);

        let defaultZoneDDD =
          (Zone_List.find((list) => list.id == currZoneId) ?? null);
        /* let chosenValuesDataZoneAA = {};
        chosenValuesDataZoneAA["ZoneId"] = defaultZoneDDD; */
        setChosenValuesZone(defaultZoneDDD);
      })
      .catch((err) => {});
  };

  const cCommuneList = () => {
    let CommuneListParam = {
      action: "Communelist",
      RegionId: currRegionId,
      ZoneId: currZoneId,
      FacilityId: FacilityId,
      menukey: "",
    };

    Service.default
      .postApi("source/combo_generic.php", CommuneListParam)
      .then((res) => {
        let All_Commune_label = objAll;
        const Commune_List = [All_Commune_label].concat(res.datalist);
        setCommuneListLocal(Commune_List);

        let defaultCommune =
          (Commune_List.find((list) => list.id == currCommuneId) ?? null);
        /* let chosenValuesDataCommune = {};
      chosenValuesDataCommune["DistrictId"] = defaultCommune; */
        setChosenValuesDistrict(defaultCommune);
      })
      .catch((err) => {});
  };

  const cFacilityList = () => {
    let FacilityListParam = {
      action: "ARVFacilityListByDepartmentZoneCommune",
      RegionId: currRegionId,
      ZoneId: currZoneId,
      DistrictId: currCommuneId,
      menukey: "",
    };

    Service.default
      .postApi("source/combo_generic.php", FacilityListParam)
      .then((res) => {
        let All_Facility_label = objAll;
        const Facility_List = [All_Facility_label].concat(res.datalist);
        setFacilityListLocal(Facility_List);
        let defaultFacilityDDD =
          (Facility_List.find(
              (facilitylist) => facilitylist.id == currFacilityId
            ) ?? null);

        /* let chosenValuesDataFacilityAA = {};
        chosenValuesDataFacilityAA["FacilityId"] = defaultFacilityDDD; */

        setChosenValuesFacility(defaultFacilityDDD);
      })
      .catch((err) => {});
  };

  const [selectedStartDate, setSelectedStartDate] = React.useState(
    format(new Date(), 'dd-MM-yyyy')
  );

  /*  const { mutate: cFacilityList } = useMutation(

    api.gFacilitylist,
    {
      onSuccess: (data) => {
        if (data.status == 200) {
      
          let All_Facility_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All Facility"])};
          const Facility_List = [All_Facility_label].concat(data.data.datalist); 
          setACValue({ id: '0', name: t(DispensingLanguage[lan][menukey]["All Facility"])});
          setFacilitylist(Facility_List);
          setCurrFacilityId(0);


        }
        
      },
    }
  ); */

  /* const [acValue, setACValue] = useState({ id: '0', name: t(DispensingLanguage[lan][menukey]["All Facility"])});

const handleFacilityChange = (val) => {
  setACValue(val);
  if(val != null){
  setCurrFacilityId(val.id);


  }
  
  
}; */

  /* const [acKeyPopulationTypeValue, setACKeyPopulationTypeValue] = useState({ id: '0', name: t(DispensingLanguage[lan][menukey]["All Key Population Type"])});

const handleKeyPopulationTypeValueChange = (val) => {
  setACKeyPopulationTypeValue(val);
  if(val != null){
    setCurrKeypopulationTypeId(val.id);


  }
  
  
};
 */

  /* end new filter */

  //exporting(Highcharts);
  const classes = useStyles();

  const [pickerData, setPickerData] = useState([
    {
      startDate: subDays(new Date(), 29),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [isLoadingDashboard, setLoading] = useState(true);

  let params1 = {
    action: "getInformationSheetForPLHIVPatientsOnINHProphylaxisTable",
    menukey: menukey,
    RegionId: currRegionId,
    ZoneId: currZoneId,
    CommuneId: currCommuneId,
    FacilityId: currFacilityId,
    //KeypopulationTypeId: currKeypopulationTypeId,
    /* ItemNo: currPorductId, */
    /* StartDate: selectedStartDate,
    EndDate: selectedEndDate, */
  };
  const [dataItems, setDataItems] = useState([]);
  const { refetch } = useQuery(
    [params1],
    api.getInformationSheetForPLHIVPatientsOnINHProphylaxisTable,
    {
      onSuccess: (data) => {
        setDataItems(data);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );

  /*  useEffect(() => {
    if (currYearId > 0 && currMonthId > 0) {
      getConsumptionTrendsTopFiveProducts.refetch();
    }
  }, [currFacilityId]); */

  const [RedirectLogin, setRedirectLogin] = React.useState(true);
  const [hasUserPermission, setHasUserPermission] = React.useState(false);

  /* const checkLogin = () => {
    let token = sessionStorage.getItem("token");
    if (!token) {
      swal({
        title: "Oops!",
        text: 'token expired. Please login again',
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) { 
          window.location.href = process.env.REACT_APP_BASE_NAME+`/login`;
          sessionStorage.clear();
        }
      });
    }
  }; */

  if (RedirectLogin) {
    setHasUserPermission(checkUserPermission(menukey)); // To check user has permission in this page
    checkLogin();
    setRedirectLogin(false);
  }

  React.useEffect(() => {
    // checkLogin();
  }, []);

  const handleDatePicker = (e) => {};

  const columns = [
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#."]),
      formatter: "rownum",
      width: 45,
      hozAlign: "center",
      headerSort: false,
      headerHozAlign: "center",
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Date"]),
      width: 110,
      field: "registered",
      headerFilter: true,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return format(new Date(value), 'dd/MM/yyyy');
      },
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Patient Code"]),
      field: "idNumber",
      headerFilter: true,
      //width: 140,
      minWidth: 100,
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Category (N/A)"]),
      field: "pass",
      headerFilter: true,
      width: 120,
      visible: false,
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Gender (M/F)"]),
      field: "gender",
      headerFilter: true,
      width: 120,
    },

    //Age group column start

    {
      title: t(DispensingLanguage[lan][menukey]["Age"]),
      hozAlign: "center",
      headerHozAlign: "center",
      columns: [
        {
          title: "<15",
          field: "LessThan15",
          hozAlign: "center",
          headerHozAlign: "center",
          headerFilter: false,
          width: "80",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: "15-24",
          field: "15to24",
          hozAlign: "center",
          headerHozAlign: "center",
          headerFilter: false,
          width: "80",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },

        {
          title: "25-49",
          field: "25to49",
          hozAlign: "center",
          headerHozAlign: "center",
          headerFilter: false,
          width: "80",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: "50+",
          field: "50Plus",
          hozAlign: "center",
          headerHozAlign: "center",
          headerFilter: false,
          width: "80",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },
    //Age end

    {
      title:
        t(DispensingLanguage[lan][menukey][
          "Has the patient previously received INH treatment?"
        ]),
      field: "InhIsPrevious",
      hozAlign: "center",
      headerHozAlign: "center",
      headerFilter: true,
      width: 180,
    },

    {
      title: t(
        DispensingLanguage[lan][menukey][
          "Start date of current preventive therapy with INHagainst tuberculosis"
        ]
      ),
      width: 180,
      field: "InhStartDate",
      headerFilter: true,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        if (value === "" || value === null) {
          return "";
        } else {
          return format(new Date(value), 'dd/MM/yyyy');
        }
      },
    },

    {
      title: t(
        DispensingLanguage[lan][menukey][
          "End date of current preventive therapy with INHagainst tuberculosis"
        ]
      ),
      width: 180,
      field: "InhEndDate",
      headerFilter: true,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        if (value === "" || value === null) {
          return "";
        } else {
          return format(new Date(value), 'dd/MM/yyyy');
        }
      },
    },
  ];

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;
  //let StartDate = format(new Date(selectedStartDate), 'yyyy-MM-dd');
  //let EndDate = format(new Date(selectedEndDate), 'yyyy-MM-dd');
  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";
    let currFacilityName =
      (FacilityList.find(
          (Facility_List) => Facility_List.id == currFacilityId
        ) ?? null).name;
    let currDepartmentName =
      (Regionlist.find((List) => List.id == currRegionId) ?? null).name;
    let currZoneName =
      (ZoneList.find((List) => List.id == currZoneId) ?? null).name;
    let currCommuneName =
      (CommuneList.find((List) => List.id == currCommuneId) ?? null)
        .name;

    window.open(
      finalUrl +
        "?action=InformationSheetForPLHIVPatientsOnINHProphylaxisExport" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&TimeStamp=" +
        Date.now() +
        "&StartDate=" +
        selectedStartDate +
        /*   
        "&EndDate=" + EndDate + */
        "&RegionId=" +
        currRegionId +
        "&ZoneId=" +
        currZoneId +
        "&CommuneId=" +
        currCommuneId +
        "&FacilityId=" +
        currFacilityId +
        "&FacilityName=" +
        currFacilityName +
        "&DepartmentName=" +
        currDepartmentName +
        "&ZoneName=" +
        currZoneName +
        "&CommuneName=" +
        currCommuneName
      /* "&KeypopulationTypeId=" + currKeypopulationTypeId */
    );
  };
  /* =====End of Excel Export Code==== */

  return (
    hasUserPermission && (
      <>
        <AfterLoginNavbar {...props} />

        <div
          className="section signup-top-padding"
          style={{
            backgroundImage: "url(" + require("assets/img/bg8.jpg") + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center",
            minHeight: "753px",
          }}
        >
          <div className="dashboard-pannel">
            <div className="d-flex justify-product mb-1">
              <div className="sw_page_heading">
                <div className="sw_heading_title">
                  {t(
                    DispensingLanguage[lan][menukey][
                      "Information sheet for PLHIV patients on INH prophylaxis"
                    ]
                  )}
                </div>
              </div>
            </div>

            {/* start of filter */}
            <Card className="sw_card sw_filter_card">
              <CardContent className="sw_filterCardContent">
                <Grid container spacing={1}>
                  <Grid item xs={2} sm={2}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        disableClearable
                        id="RegionId"
                        options={Regionlist}
                        onChange={(event, valueobj) =>
                          handleChangeChoosenRegion(
                            "RegionId",
                            valueobj,
                            valueobj ? valueobj.id : ""
                          )
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                        value={chosenValuesRegion}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">{option.name}</Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              DispensingLanguage[lan][menukey]["Department"]
                            }
                            variant="standard"
                            id="RegionId"
                            name="RegionId"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={2} sm={2}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        disableClearable
                        id="ZoneId"
                        options={ZoneList}
                        onChange={(event, valueobj) =>
                          handleChangeChoosenZone(
                            "ZoneId",
                            valueobj,
                            valueobj ? valueobj.id : ""
                          )
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                        value={chosenValuesZone}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">{option.name}</Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={DispensingLanguage[lan][menukey]["ZS"]}
                            variant="standard"
                            id="ZoneId"
                            name="ZoneId"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={2} sm={2}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        disableClearable
                        id="DistrictId"
                        options={CommuneList}
                        onChange={(event, valueobj) =>
                          handleChangeChoosenDistrict(
                            "DistrictId",
                            valueobj,
                            valueobj ? valueobj.id : ""
                          )
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                        value={chosenValuesDistrict}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">{option.name}</Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={DispensingLanguage[lan][menukey]["Commune"]}
                            variant="standard"
                            id="DistrictId"
                            name="DistrictId"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>

                  {/* <Grid item xs={3} sm={3}>
                      <FormControl className={classes.fullWidth}> 
                        <Autocomplete
                                    
                            autoHighlight={true}
                            id="Facilitylist"
                            options={Facilitylist} 
                            disableClearable
                            onChange={(event, value) => handleFacilityChange(value)} 
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            //value={acValue}
                            defaultValue={Facilitylist[Facilitylist.findIndex(facilitylist => facilitylist.id == currFacilityId)]}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                            <TextField
                              {...params}
                              //value={formData.Facilitylist}
                              label={DispensingLanguage[lan][menukey]["Facility"] }
                              variant="standard"
                              fullWidth
                            />
                            )}
                          />
                          

                      </FormControl> 
                        
                      </Grid> */}

                  <Grid item xs={3} sm={3}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        disableClearable
                        id="FacilityId"
                        options={FacilityList}
                        onChange={(event, valueobj) =>
                          handleChangeChoosenFacility(
                            "FacilityId",
                            valueobj,
                            valueobj ? valueobj.id : ""
                          )
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                        value={chosenValuesFacility}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">{option.name}</Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={DispensingLanguage[lan][menukey]["Facility"]}
                            variant="standard"
                            id="FacilityId"
                            name="FacilityId"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>

                  {/* <Grid item xs={3} sm={3}>
                      <FormControl className={classes.fullWidth}> 
                        <Autocomplete
                                    
                            autoHighlight={true}
                            id="KeyPopulationTypelist"
                            options={KeyPopulationTypelist} 
                            disableClearable
                            onChange={(event, value) => handleKeyPopulationTypeValueChange(value)} 
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={acKeyPopulationTypeValue}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                            <TextField
                              {...params}
                              label={DispensingLanguage[lan][menukey]["Key Population Type"] }
                              variant="standard"
                              fullWidth
                            />
                            )}
                          />
                          

                      </FormControl> 
                        
                      </Grid> */}

                  <Grid item xs={1} sm={1}>
                    <div className="firstProtocolName marginTop20">
                      <h6>
                        {DispensingLanguage[lan][menukey]["Date"]}
                        {": "}
                        {selectedStartDate}
                      </h6>
                    </div>
                  </Grid>

                  <Grid item xs={2} sm={2}>
                    <div className="float-end sw_btn_control">
                      <Button
                        color="info"
                        className="me-2 sw_icons"
                        onClick={() => PrintPDFExcelExportFunction("print")}
                      >
                        <i className="fas fa-print"></i>
                      </Button>

                      <Button
                        color="info"
                        className="me-2 sw_icons"
                        onClick={() => PrintPDFExcelExportFunction("excel")}
                      >
                        <i className="far fa-file-excel"></i>
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {/* end of filter */}

            {/* new row */}
            <div className="row">
              <div className="col-md-12">
                <Card className="sw_card">
                  {/*  <CardHeader
                      
                    /> */}

                  <CardContent>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="uniqueName">
                          <ReactTabulator
                            columns={columns}
                            data={dataItems}
                            layout={"fitColumns"}
                            height="600px"
                            options={{
                              //groupBy: ["FacilityName", "GroupName"],
                              groupBy: "FacilityName",
                              columnCalcs: "both",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
            {/* end row */}
          </div>
        </div>
      </>
    )
  );
};

export default ReportPage;

const useStyles = makeStyles({
  root: {
    width: "20%",
    margin: "0 1rem",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  cardDiv: {
    display: "flex",
  },
  fullWidth: {
    width: "100%",
  },
});
